import { StarNameMap } from "pages/Numerology/DetailStar";
import { mixGetV1, mixPostV1 } from "services/mixin";
import jsPDF from "jspdf";
import html2canvas from "html2canvas-oklch";
import { PDFDocument } from "pdf-lib";
import { useEffect, useRef, useState } from "react";
// @ts-ignore
import './../pdf.css';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const innerContentPaddingX = '48px';
const spaceBreakError = 400;

const FreePDF = () => {
    const [data, setData] = useState<any>("");
    const [user, setUser] = useState<any>(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null);

    const [loading, setLoading] = useState(false);
    const [createStatus, setCreateStatus] = useState<string>("");
    const { t, i18n } = useTranslation();

    const currentLang = i18n.language;
    const [name, setName] = useState<string>(currentLang == "vi" ? user.last_name + " " + user.first_name : user.first_name + " " + user.last_name);
    const [dob, setDob] = useState<string>(user?.birthday || "");
    const contentRef = useRef<HTMLDivElement>(null);

    async function getUser(uid: string) {
        try {
            const res = await mixGetV1(`/api/v1/be/user/${uid}`);
            if (res.status) {
                return res.data;
            } else {
                console.error("Get user failed:", res);
                return null;
            }
        } catch (error) {
            console.error("Get user failed:", error);
            return null;
        }
    }

    const [documentMap, setDocumentMap] = useState([
        {
            section: "Core Indices",
            section_id: "core_indices",
            section_full_name: {
                en: "Core Indices",
                vi: "Chỉ số cốt lõi"
            },
            items: [
                {
                    name: "Path-Potential Alignment (PPA)",
                    slug: "PPA",
                    id: ["5"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_PPA_Index_Cover.png`
                    ]
                },
                {
                    name: "Skill Potential Index (SPI)",
                    slug: "SPI",
                    id: ["11"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_SPI_Index_Cover.png`
                    ]
                },
                {
                    name: "Path-Potential Alignment Index (PPAI)",
                    slug: "PPAI",
                    id: ["5"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_PPAI_Index_Cover.png`
                    ]
                },
                {
                    name: "Emotional Drive Index (EDI)",
                    slug: "EDI",
                    id: ["3"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_EDI_Index_Cover.png`
                    ]
                }
            ]
        },
        {
            section: "Indicators of behavior, emotions, and personal discipline",
            section_id: "behavior_emotion_discipline_index",
            section_full_name: {
                en: "Indicators of behavior, emotions, and personal discipline",
                vi: "Chỉ số về hành vi, cảm xúc, kỷ luật cá nhân"
            },
            items: [
                {
                    name: "Crisis Management Index (CMI)",
                    slug: "CMI",
                    id: ["9"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_CMI_Index_Cover.png`
                    ]
                },
                {
                    name: "Inner-Outer Coherence Index (IOCI)",
                    slug: "IOCI",
                    id: ["5"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_IOCI_Index_Cover.png`
                    ]
                },
                {
                    name: "Market Persona Index (MPI)",
                    slug: "MPI",
                    id: ["6"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_MPI_Index_Cover.png`
                    ]
                },
                {
                    name: "Resilience Index (RI)",
                    slug: "RI",
                    id: ["8"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_RI_Index_Cover.png`
                    ]
                },
                {
                    name: "Trading Attitude Index (TAI)",
                    slug: "TAI",
                    id: ["7"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_TAI_Index_Cover.png`
                    ]
                }
            ]
        },
        {
            section: "MINDSET INDEX",
            section_id: "mindset_index",
            section_full_name: {
                en: "MINDSET INDEX",
                vi: "CHỈ SỐ VỀ TƯ DUY, RA QUYẾT ĐỊNH, MINDSET"
            },
            items: [
                {
                    name: "Natural Edge Index (NEI)",
                    slug: "NEI",
                    id: ["4"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_NEI_Index_Cover.png`
                    ]
                },
                {
                    name: "Strength Amplifier Index (SAI)",
                    slug: "SAI",
                    id: ["4"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_SAI_Index_Cover.png`
                    ]
                },
                {
                    name: "Analytical Reasoning Index (ARI)",
                    slug: "ARI",
                    id: ["4"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_ARI_Index_Cover.png`
                    ]
                },
                {
                    name: "Behavioral Liability Index (BLI)",
                    slug: "BLI",
                    id: ["4"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_BLI_Index_Cover.png`
                    ]
                },
                {
                    name: "Weakness Map Index (WMI)",
                    slug: "WMI",
                    id: ["4"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_WMI_Index_Cover.png`
                    ]
                },
                {
                    name: "Subconscious Stability Index (SSI)",
                    slug: "SSI",
                    id: ["4"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_SSI_Index_Cover.png`
                    ]
                },
            ]
        },
        {
            section: "Time and sentiment index",
            section_id: "time_sentiment_index",
            section_full_name: {
                en: "Time and sentiment index",
                vi: "Chỉ số về thời gian và biến động tâm lý "
            },
            items: [
                {
                    name: "Cohort Influence Index (CII)",
                    slug: "CII",
                    id: ["8"]
                },
                {
                    name: "TRADING CYCLE INDEX (TCI)",
                    slug: "TCI",
                    id: ["7", "6", "4", "1"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_TCI1_Index_Cover.png`,
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_TCI2_Index_Cover.png`,
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_TCI3_Index_Cover.png`,
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_TCI4_Index_Cover.png`
                    ]
                },
                {
                    name: "Behavioral Challenge Index (BCI)",
                    slug: "BCI",
                    id: ["1", "1", "0", "0"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_BCI1_Index_Cover.png`,
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_BCI2_Index_Cover.png`,
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_BCI3_Index_Cover.png`,
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_BCI4_Index_Cover.png`
                    ]
                },
                {
                    name: "Annual Momentum Index (AMI)",
                    slug: "AMI",
                    id: ["5"],
                    img: [
                        //`/TBI_pdf/${currentLang}/LUMIR_TBI_AMI_Index_Cover.png`
                    ]
                },
            ]
        }
    ]);
    useEffect(() => {
        if (user) {
            if (!user.first_name && !user.last_name || user.first_name === null && user.last_name === null) {
                getUser(user.id).then((fetchedUser) => {
                    if (fetchedUser) {
                        if (fetchedUser.first_name && fetchedUser.last_name && fetchedUser.first_name !== null && fetchedUser.last_name !== null) {
                            setUser(fetchedUser);
                        }
                    }
                });
            }

        } else {
            getUser(user.id).then((fetchedUser) => {
                if (fetchedUser) {
                    if (fetchedUser.first_name && fetchedUser.last_name && fetchedUser.first_name !== null && fetchedUser.last_name !== null) {
                        setUser(fetchedUser);
                    }
                }
            });
        }
    }, []);

    useEffect(() => {
        const getIndexNumber = async () => {
            try {
                const formatDateDDMMYYYY = (d: Date) => {
                    const dd = String(d.getDate()).padStart(2, "0");
                    const mm = String(d.getMonth() + 1).padStart(2, "0");
                    const yyyy = d.getFullYear();
                    return `${dd}/${mm}/${yyyy}`;
                };

                const rawDob = user?.birthday || "";
                let dateOnlyDob = "";
                if (rawDob) {
                    // extract the date part if there's time
                    const datePart = rawDob.includes(" ")
                        ? rawDob.split(" ")[0]
                        : rawDob.includes("T")
                            ? rawDob.split("T")[0]
                            : rawDob;

                    // normalize separators to '-' for easier parsing
                    const normalized = datePart.replace(/\//g, "-");
                    const parts = normalized.split("-");

                    if (parts.length === 3) {
                        // yyyy-mm-dd -> dd/mm/yyyy
                        if (parts[0].length === 4) {
                            const [yyyy, mm, dd] = parts;
                            dateOnlyDob = `${dd.padStart(2, "0")}/${mm.padStart(2, "0")}/${yyyy}`;
                        }
                        // dd-mm-yyyy or mm-dd-yyyy -> assume dd-mm-yyyy
                        else if (parts[2].length === 4) {
                            const [dd, mm, yyyy] = parts;
                            dateOnlyDob = `${dd.padStart(2, "0")}/${mm.padStart(2, "0")}/${yyyy}`;
                        } else {
                            dateOnlyDob = datePart;
                        }
                    } else {
                        // fallback: parse with Date and format
                        const d = new Date(datePart);
                        if (!isNaN(d.getTime())) {
                            const dd = String(d.getDate()).padStart(2, "0");
                            const mm = String(d.getMonth() + 1).padStart(2, "0");
                            const yyyy = d.getFullYear();
                            dateOnlyDob = `${dd}/${mm}/${yyyy}`;
                        } else {
                            dateOnlyDob = datePart;
                        }
                    }
                } else {
                    dateOnlyDob = "";
                }
                setDob(dateOnlyDob);
                const res = await mixPostV1(`/api/v1/pwi/calculate`, {
                    full_name: currentLang == "vi" ? user.last_name + " " + user.first_name : user.first_name + " " + user.last_name,
                    date_of_birth: dateOnlyDob,
                    current_date: formatDateDDMMYYYY(new Date())
                });
                const data = res.data;
                if (res.success) {
                    // replace $SELECTION_PLACEHOLDER$ with this
                    const pwi = res.data?.pwi_indices || res.data?.pwi || {};
                    if (pwi && typeof pwi === "object") {
                        const collectLeafValues = (v: any): string[] => {
                            if (v == null) return [];
                            if (Array.isArray(v)) return v.flatMap(collectLeafValues);
                            if (typeof v === "object") return Object.values(v).flatMap(collectLeafValues);
                            return [String(v)];
                        };

                        const getValuesFromPwiKey = (k: string) => {
                            if (!k) return [];
                            const raw = (pwi as any)[k];
                            if (raw == null) return [];
                            if (Array.isArray(raw)) return raw.map(String);
                            if (typeof raw === "object") return collectLeafValues(raw).map(String);
                            return [String(raw)];
                        };

                        // try to assign ids using StarNameMap first (slug -> code, pwi -> key)
                        for (const section of documentMap) {
                            for (const item of section.items) {
                                let assigned = false;

                                // if item represents multiple sub-items (e.g., TCI with 4 slots),
                                // try mapping each slot to a StarNameMap entry like TCI1, TCI2...
                                if (Array.isArray(item.id) && item.id.length > 1) {
                                    const collected: string[] = [];
                                    for (let i = 0; i < item.id.length; i++) {
                                        const variantCode = `${item.slug}${i + 1}`;
                                        const mapEntry =
                                            (StarNameMap as any[]).find((s) => String(s.code).toLowerCase() === String(variantCode).toLowerCase()) ||
                                            (StarNameMap as any[]).find((s) => String(s.code).toLowerCase() === String(item.slug).toLowerCase());
                                        if (mapEntry && mapEntry.key) {
                                            const vals = getValuesFromPwiKey(mapEntry.key);
                                            if (vals.length) {
                                                collected.push(...vals);
                                                assigned = true;
                                            }
                                        }
                                    }
                                    if (collected.length > 0) {
                                        item.id = collected;
                                    }
                                } else {
                                    // single-slot item: find map entry by exact code match (case-insensitive)
                                    const mapEntry = (StarNameMap as any[]).find(
                                        (s) => String(s.code).toLowerCase() === String(item.slug).toLowerCase()
                                    );

                                    if (mapEntry && mapEntry.key) {
                                        const vals = getValuesFromPwiKey(mapEntry.key);
                                        if (vals.length) {
                                            item.id = vals;
                                            assigned = true;
                                        }
                                    }
                                }

                                // fallback: if StarNameMap didn't yield anything, attempt a best-effort match
                                // against keys in pwi (normalizing & partial matches)
                                if (!assigned) {
                                    const normalize = (s: any) =>
                                        String(s || "")
                                            .toLowerCase()
                                            .replace(/[^a-z0-9]/g, "");
                                    const acronym = (s: string) =>
                                        String(s || "")
                                            .split(/[_\s-]+/)
                                            .map((w) => w[0] || "")
                                            .join("")
                                            .toLowerCase();

                                    const slugNorm = normalize(item.slug);
                                    let matchedKey = Object.keys(pwi).find((k) => {
                                        const kNorm = normalize(k);
                                        return (
                                            slugNorm === kNorm ||
                                            slugNorm === acronym(k) ||
                                            kNorm === acronym(item.slug) ||
                                            kNorm.startsWith(slugNorm) ||
                                            slugNorm.startsWith(kNorm)
                                        );
                                    });

                                    if (!matchedKey) {
                                        matchedKey = Object.keys(pwi).find((k) => {
                                            const kNorm = normalize(k);
                                            return kNorm.includes(slugNorm) || slugNorm.includes(kNorm);
                                        });
                                    }

                                    if (matchedKey) {
                                        const raw = (pwi as any)[matchedKey];
                                        let ids: string[] = [];
                                        if (Array.isArray(raw)) {
                                            ids = raw.map(String);
                                        } else if (typeof raw === "object" && raw !== null) {
                                            ids = collectLeafValues(raw).filter(Boolean).map(String);
                                        } else {
                                            ids = [String(raw)];
                                        }
                                        if (ids.length > 0) {
                                            item.id = ids;
                                        }
                                    }
                                }
                            }
                        }
                        setDocumentMap([...documentMap]);
                        setCreateStatus(t("TBI_PDF_status_complete_data"));
                    } else {
                        console.warn("No pwi_indices found in response:", res.data);
                    }
                }
                else {
                    console.error("Get index number failed:", res);
                }
            }
            catch (error) {
                console.error("Get index number failed:", error);
            }
        }

        if (user && user.first_name && user.last_name && user.birthday) {
            getIndexNumber();
        }
        else {
            toast.error(t("TBI_PDF_error_incomplete_profile"));
        }
    }, [user, currentLang]);

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const allRequests: Promise<string | null>[] = [];
                let sectionIndex = 0;
                const fontpage = `
                        <section class="section-image exclude-list" data-section="fontPage" style="page-break-before: always; break-before: page; page-break-after: always; break-after: page; width:100%; height:100%;position:relative; ">
                            <div style="width:100%;  display:flex; align-items:center; justify-content:center; background:#000;">
                                <img src="/TBI_pdf/${currentLang}/fontBanner.png" alt="fontBanner" style="width:100%; height:100%; object-fit:cover; display:block; " crossorigin="anonymous"/>
                            </div>
                            <div style="position:absolute; top:6.25rem; width:100%; text-align:center; color:#fff; font-size:18px;">
                                <span style="font-size:1.5rem; font-weight:bold;"> ${currentLang == "vi" ? user.last_name + " " + user.first_name : user.first_name + " " + user.last_name || ""} </span><br/>
                                <span style="font-size:1rem;">
                                    ${dob || ""}
                                </span>
                            </div>
                            
                        </section>
                    `;
                allRequests.push(Promise.resolve(fontpage));
                for (const section of documentMap) {
                    const sectionIntro = `
                        <section class="section-image exclude-list" data-section="${section.section_id}" style="page-break-before: always; break-before: page; page-break-after: always; break-after: page; width:100%; height:100%;">
                            <div style="width:100%;  display:flex; align-items:center; justify-content:center; background:#000;">
                                <img src="/TBI_pdf/${currentLang}/${section.section_id}.png" alt="${section.section_id}" style="width:100%; height:100%; object-fit:cover; display:block;" crossorigin="anonymous"/>
                            </div>
                        </section>
                    `;
                    allRequests.push(Promise.resolve(sectionIntro));
                    sectionIndex++;

                    for (const item of section.items) {
                        let itemIndex = 0;
                        for (const id of item.id) {
                            const slugKey = item.id.length > 1 ? `${item.slug}${itemIndex + 1}` : item.slug;
                            const slugFormat = StarNameMap.find((x) => x.code === slugKey);
                            if (!slugFormat) continue;
                            const imgs = Array.isArray(item.img) ? item.img : item.img ? [item.img] : [];

                            if (imgs.length > 0) {
                                const imgSrc = imgs[itemIndex] ?? imgs[0];

                                // create a full-page image block (forces a page break before and after)
                                const imgPage = `
                                    <section class="section-image exclude-list" data-section="${section.section_id}" style="page-break-before: always; break-before: page; page-break-after: always; break-after: page; width:100%; height:100%;">
                                        <div style="width:100%;  display:flex; align-items:center; justify-content:center; background:#000;">
                                            <img src="${imgSrc}" style="width:100%; height:100%; object-fit:cover; display:block;" crossorigin="anonymous" />
                                        </div>
                                    </section>
                                `;

                                allRequests.push(Promise.resolve(imgPage));
                            }

                            itemIndex = itemIndex + 1;

                            const req = mixGetV1(
                                `/api/v1/be/numerology_indices?key=${slugFormat.key}&number=${id}&page=1&limit=1`
                            )
                                .then((res) => {
                                    if (res.status && res.data?.items?.[0]?.description) {
                                        const descRaw = res.data.items[0].description;
                                        let html = "";
                                        try {
                                            const parsed = typeof descRaw === "string" ? JSON.parse(descRaw) : descRaw;
                                            if (typeof parsed === "string") {
                                                html = parsed;
                                            } else if (parsed && typeof parsed === "object") {
                                                // prefer currentLang, fallback to en, then vi, then whole object
                                                html = (parsed as Record<string, any>)[currentLang] ?? parsed.en ?? parsed.vi ?? JSON.stringify(parsed);
                                            } else {
                                                html = "";
                                            }
                                        } catch (err) {
                                            console.warn("Failed to parse description JSON:", err);
                                            html = String(descRaw || "");
                                        }
                                        return `<h2 class="section-heading" data-section="${section.section_id}" style="page-break-before: always; break-before: page;"></h2>${html}<div style="page-break-after: always; break-after: page;"></div>`;
                                    }
                                    return null;
                                })
                                .catch((err) => {
                                    console.error(`Error fetching ${item.slug}:`, err);
                                    return null;
                                });

                            allRequests.push(req);
                        }
                    }
                }

                // Await all requests
                const results = await Promise.all(allRequests);
                // Merge all HTML parts into one
                const mergedHTML = results.filter(Boolean).join("");

                setData(mergedHTML);
            } catch (error) {
                console.error("Fetch all data failed:", error);
            }
            finally {
                setCreateStatus(t("TBI_PDF_status_ready"));
            }
        };
        fetchAllData();
    }, [documentMap, currentLang]);


    const handleExportPdf = async () => {
        if (loading) return;
        setLoading(true);

        const container = contentRef.current;
        if (!container || !data) {
            alert("Dữ liệu chưa sẵn sàng");
            setCreateStatus(t("TBI_PDF_status_not_ready"));
            setLoading(false);
            return;
        }

        await new Promise((r) => setTimeout(r, 300));

        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = 210;
        const pdfHeight = 297;

        const pageMargin = 0;
        const usableHeight = pdfHeight - pageMargin * 2;

        const topLevelBlocks = Array.from(container.children) as HTMLElement[];

        // create a temporary off-screen page to measure content height
        const tempPage = document.createElement("div");
        tempPage.style.width = "794px";
        tempPage.style.minHeight = "1122px";
        tempPage.style.padding = "100px 42px";
        tempPage.style.boxSizing = "border-box";
        tempPage.style.background = "white";
        tempPage.style.position = "relative";
        tempPage.style.left = "-9999px";
        tempPage.style.color = "#000000";
        tempPage.className = "pdfPage";
        document.body.appendChild(tempPage);

        let currentHeight = 0;
        let currentGroup: HTMLElement[] = [];
        const groupedPages: HTMLElement[][] = [];
        let page_count = 0;
        for (const block of topLevelBlocks) {
            const clone = block.cloneNode(true) as HTMLElement;
            tempPage.appendChild(clone);

            const blockHeight = clone.offsetHeight;

            // if this block is a section heading, force a new page start
            const isSectionIntro = clone.classList?.contains?.("section-intro");
            if (isSectionIntro) {
                if (currentGroup.length > 0) {
                    groupedPages.push(currentGroup);
                }
                // make the section intro a standalone page
                groupedPages.push([block]);
                currentGroup = [];
                currentHeight = 0;
                tempPage.innerHTML = "";
                continue;
            }
            const isSectionHeading =
                (clone.matches && clone.matches("h2.section-heading")) ||
                !!clone.querySelector?.("h2.section-heading");

            if (isSectionHeading) {
                if (currentGroup.length > 0) {
                    groupedPages.push(currentGroup);
                }
                currentGroup = [block];
                currentHeight = blockHeight;

                tempPage.innerHTML = "";
                tempPage.appendChild(clone);
                continue;
            }

            const isSectionImage = clone.classList?.contains?.("section-image") || block.classList?.contains?.("section-image");
            if (isSectionImage) {
                // Force section-image to be its own page
                if (currentGroup.length > 0) {
                    groupedPages.push(currentGroup);
                    for (const b of currentGroup) {
                        b.style.padding = "0";
                    }
                }
                groupedPages.push([block]);
                currentGroup = [];
                currentHeight = 0;
                tempPage.innerHTML = "";
                page_count++;
                // no need to append clone back since we treat it as its own page
                continue;
            }

            if (currentHeight + blockHeight > 1122 - spaceBreakError) {
                const tag = block.tagName?.toLowerCase();
                const blockStyles = window.getComputedStyle(block);

                const pageBreakBefore = blockStyles.getPropertyValue("page-break-before") || blockStyles.getPropertyValue("break-before");
                if (tag === "ul" || tag === "ol") {
                    const prev = currentGroup.pop();
                    if (prev) {
                        const prevClone = prev.cloneNode(true) as HTMLElement;
                        tempPage.innerHTML = "";
                        tempPage.appendChild(prevClone);
                        const prevHeight = prevClone.offsetHeight;

                        groupedPages.push(currentGroup);
                        currentGroup = [prev, block];
                        currentHeight = prevHeight + blockHeight;
                    } else {
                        groupedPages.push(currentGroup);
                        currentGroup = [block];
                        currentHeight = block.offsetHeight;
                    }
                }
                else if (pageBreakBefore === "always" || pageBreakBefore === "page") {
                    // nếu block có thuộc tính page-break-before thì tách trang trước
                    groupedPages.push(currentGroup);
                    currentGroup = [block];
                    currentHeight = block.offsetHeight;
                }
                else {
                    groupedPages.push(currentGroup);
                    currentGroup = [block];
                    currentHeight = block.offsetHeight;
                }

                tempPage.innerHTML = "";
                tempPage.appendChild(block.cloneNode(true));
            }
            else {
                currentGroup.push(block);
                currentHeight += blockHeight;
            }
            page_count++;
            setCreateStatus(t('TBI_PDF_status_processing_block', { block: groupedPages.length + 1 }));
        }

        // push remaining blocks
        if (currentGroup.length > 0) groupedPages.push(currentGroup);

        document.body.removeChild(tempPage);

        const pdfBlobs: Blob[] = [];

        for (let pageIndex = 0; pageIndex < groupedPages.length; pageIndex++) {
            const pageBlocks = groupedPages[pageIndex];

            const pageContainer = document.createElement("div");
            pageContainer.style.width = "794px";
            pageContainer.style.minHeight = "1122px";
            pageContainer.style.background = "white";
            pageContainer.className = "pdfPage";
            // top padding should account for header height, bottom padding for footer height
            // adjust padding: if the page contains a full-page section-image, remove padding
            const hasSectionImageForPadding = pageBlocks.some((b) =>
                (b.classList && b.classList.contains?.("section-image")) ||
                !!b.querySelector?.(".section-image")
            );

            if (hasSectionImageForPadding) {
                // no padding for image-only pages
                pageContainer.style.padding = "0";
            } else {
                // account for header/footer on normal pages
                pageContainer.style.padding = `80px 80px 60px`;
            }
            pageContainer.style.boxSizing = "border-box";
            pageContainer.style.position = "relative";

            // append content blocks
            pageBlocks.forEach((b) => pageContainer.appendChild(b.cloneNode(true)));

            // add header and footer (use the factory functions)
            const containsSectionImage = pageBlocks.some((b) =>
                (b.classList && b.classList.contains?.("section-image")) ||
                !!b.querySelector?.(".section-image")
            );

            if (!containsSectionImage) {
                if (typeof createHeaderElement === "function") {
                    const headerEl = createHeaderElement({ name, dob });
                    pageContainer.appendChild(headerEl);
                }
                if (typeof createFooterElement === "function") {
                    const footerEl = createFooterElement(pageIndex + 1);
                    pageContainer.appendChild(footerEl);
                }
            }

            document.body.appendChild(pageContainer);

            const canvas = await html2canvas(pageContainer, {
                scale: 1,
                useCORS: true,
                backgroundColor: "#ffffff",
            });

            document.body.removeChild(pageContainer);

            const imgData = canvas.toDataURL("image/jpg");
            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

            const pagePdf = new jsPDF("p", "mm", "a4");
            pagePdf.addImage(imgData, "jpg", 0, 0, pdfWidth, imgHeight);
            const blob = pagePdf.output("blob");
            pdfBlobs.push(blob);
            setCreateStatus(t('TBI_PDF_status_create_page', { current: pageIndex + 1, total: groupedPages.length }));
        }

        // Gộp lại
        const mergedPdf = await PDFDocument.create();
        let pageNumber = 0;

        setCreateStatus(t('TBI_PDF_status_finalize'));
        for (const blob of pdfBlobs) {
            const pdfBytes = await blob.arrayBuffer();
            const pdf = await PDFDocument.load(pdfBytes);
            const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
            copiedPages.forEach((page) => mergedPdf.addPage(page));
            pageNumber += pdf.getPageCount();
        }

        const mergedPdfFile = await mergedPdf.save();
        const final8Array = new Uint8Array(mergedPdfFile);
        const finalBlob = new Blob([final8Array], { type: "application/pdf" });
        const url = URL.createObjectURL(finalBlob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `TBI_TradingDNA_${user.fullname}.pdf`;
        setCreateStatus(t('TBI_PDF_status_saving'));
        link.click();
        setCreateStatus(t('TBI_PDF_status_completed'));
        setLoading(false);
    };

    return (
        <div style={{ padding: 20 }}>
            <button
                onClick={handleExportPdf}
                disabled={loading}
                style={{
                    padding: "8px 16px",
                    background: "#E9B460",
                    color: "white",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    marginBottom: "16px",
                    position: "fixed",
                    top: "20px",
                    right: "20px",
                    zIndex: 1000,
                }}
            >
                {loading ? t('TBI_PDF_Generating') : t('TBI_PDF_Download')}
            </button>
            <button
                onClick={() => window.history.back()}
                style={{
                    padding: "8px 16px",
                    background: "#6b7280",
                    color: "white",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    marginLeft: "12px",
                    position: "fixed",
                    top: "20px",
                    left: "20px",
                    zIndex: 1000,
                }}
            >
                {t('TBI_PDF_Back')}
            </button>
            <div style={{
                marginBottom: 16,
                position: "fixed",
                top: "80px",
                right: "20px",
                background: "rgba(0,0,0,0.7)",
                color: "white",
                padding: "8px 12px",
                borderRadius: "8px",
                zIndex: 1000,
            }}>{createStatus}</div>
            <div
                ref={contentRef}
                className="pdfPage"
                style={{
                    width: "100%",
                    maxWidth: "794px",
                    margin: "0 auto",
                    padding: "20px",
                    background: "white",
                }}
                dangerouslySetInnerHTML={{ __html: data }}
            />
        </div>
    );
};

export default FreePDF;

// Header.tsx DOM factory for PDF pages
export const createHeaderElement = ({ name, dob }: { name?: string; dob?: string; }) => {
    const el = document.createElement("div");
    Object.assign(el.style, {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "8px 0 0 0",
        color: "#01253C",
        position: "absolute",
        top: "0",
        left: "0",
        background: "white",
        zIndex: "10",
        boxSizing: "border-box",
    });

    const inner = document.createElement("div");
    Object.assign(inner.style, {
        width: "80%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: `0 0 16px`,
        borderBottom: "1px solid #ddd",
        boxSizing: "border-box",
    });

    const left = document.createElement("p");
    left.textContent = "https://lumir.finance";
    Object.assign(left.style, {
        color: "#E9B460",
        fontSize: "18px",
        fontWeight: "600",
        margin: "0",
    });

    const right = document.createElement("div");
    Object.assign(right.style, {
        textAlign: "right",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "center",
        gap: "2px",
    });

    const nameEl = document.createElement("p");
    nameEl.textContent = name || "";
    Object.assign(nameEl.style, {
        margin: "0",
        fontSize: "16px",
        fontWeight: "600",
        color: "#01253C",
    });

    const dobEl = document.createElement("p");
    dobEl.textContent = dob || "";
    Object.assign(dobEl.style, {
        margin: "0",
        fontSize: "13px",
        color: "#01253C",
    });

    right.appendChild(nameEl);
    right.appendChild(dobEl);

    inner.appendChild(left);
    inner.appendChild(right);
    el.appendChild(inner);

    return el;
};

// Footer.tsx
export const createFooterElement = (page: number) => {
    const el = document.createElement("div");
    Object.assign(el.style, {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        fontSize: "12px",
        color: "#777",
        position: "absolute",
        bottom: "0",
        left: "0",
        background: "white",
        zIndex: "10",
    });

    const inner = document.createElement("div");
    Object.assign(inner.style, {
        width: "80%",
        padding: "12px 0",
        borderTop: "1px solid #ddd",
        display: "flex",
        justifyContent: "space-between",
        boxSizing: "border-box",
        alignItems: "center",
    });

    // left block: logo + texts
    const left = document.createElement("div");
    Object.assign(left.style, { display: "flex", flexDirection: "row", alignItems: "center" });

    const img = document.createElement("img");
    img.src = "/images/lumir-logo-login.png";
    img.alt = "Lumir Logo";
    Object.assign(img.style, { width: "50px", height: "auto" });

    const textWrap = document.createElement("div");
    Object.assign(textWrap.style, { display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "12px", paddingBottom: "16px" });

    const p1 = document.createElement("p");
    p1.textContent = "BEQ OPS LUMIR";
    Object.assign(p1.style, { margin: "0", fontSize: "18px", color: "#777" });

    const sep = document.createElement("p");
    sep.textContent = "|";
    Object.assign(sep.style, { margin: "0 8px", fontSize: "24px", color: "#E9B460" });

    const p2 = document.createElement("p");
    p2.textContent = "Trader DNA Profile";
    Object.assign(p2.style, { margin: "0", fontSize: "18px", color: "#E9B460" });

    textWrap.appendChild(p1);
    textWrap.appendChild(sep);
    textWrap.appendChild(p2);

    left.appendChild(img);
    left.appendChild(textWrap);

    // right block: page number
    const right = document.createElement("div");
    Object.assign(right.style, {
        fontSize: "16px",
        gap: "12px",
        color: "#777",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingBottom: "16px"
    });
    right.textContent = "Page ";

    const pageSpan = document.createElement("span");
    pageSpan.textContent = String(page);
    Object.assign(pageSpan.style, { color: "#E9B460", marginLeft: "6px" });

    right.appendChild(pageSpan);

    inner.appendChild(left);
    inner.appendChild(right);
    el.appendChild(inner);

    return el;
};


// Header.tsx
export const Header = () => {
    const user =
        typeof window !== "undefined" && localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user") || "{}")
            : null;
    const name = user?.fullname || "";
    const dob = user?.birthday || "";

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "8px 32px 0",
                color: "#01253C",
                position: "absolute",
                top: 0,
                left: 0,
                background: "white",
                zIndex: 10,
                boxSizing: "border-box",
            }}
        >
            <div style={{
                width: '100%',
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: `0 ${innerContentPaddingX} 8px`,
                borderBottom: "1px solid #ddd",
            }}>
                <p style={{
                    color: "#E9B460",
                    fontSize: "18px",
                    fontWeight: "600",
                    margin: 0,
                }}>https://lumir.finance/TBI</p>
                <div
                    style={{
                        textAlign: "right",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        justifyContent: "center",
                        gap: "2px",
                    }}
                >
                    <p style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "#01253C" }}>
                        {name}
                    </p>
                    <p style={{ margin: 0, fontSize: "13px", color: "#01253C" }}>{dob}</p>
                </div>
            </div>
        </div>
    );
};

// Footer.tsx
export const Footer = ({ page }: { page: number }) => {
    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                fontSize: "12px",
                color: "#777",
                position: "absolute",
                bottom: 0,
                left: 0,
                background: "white",
                zIndex: 10,
            }}
        >
            <div
                style={{
                    width: "80%",
                    padding: "12px 0",
                    borderTop: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "space-between",
                    boxSizing: "border-box",
                    alignItems: "center",
                }}
            >
                {/* Left block */}
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <img
                        src="/images/lumir-logo-login.png"
                        alt="Lumir Logo"
                        style={{ width: "50px", height: "auto" }}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            marginLeft: "12px",
                            paddingBottom: "16px",
                        }}
                    >
                        <p style={{ margin: 0, fontSize: "18px", color: "#777" }}>BEQ OPS LUMIR</p>
                        <p style={{ margin: "0 8px", fontSize: "24px", color: "#E9B460" }}>|</p>
                        <p style={{ margin: 0, fontSize: "18px", color: "#E9B460" }}>Trader DNA Profile</p>
                    </div>
                </div>

                {/* Right block */}
                <div
                    style={{
                        fontSize: "16px",
                        gap: "12px",
                        color: "#777",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingBottom: "16px",
                    }}
                >
                    Page <span style={{ color: "#E9B460", marginLeft: "6px" }}>{page}</span>
                </div>
            </div>
        </div>
    );
};


export const SectionPage = ({ sectionTitle, sectionItem }: { sectionTitle: string; sectionItem: string[] }) => {
    return (
        <div style={{
            marginBottom: "20px",
            height: "1122px",
            width: "794px",
            boxSizing: "border-box",
            padding: "80px 42px",
            background: "white",
        }}>
            <h2>{sectionTitle}</h2>
            <ul>
                {sectionItem.map((item, index) => (
                    <li
                        style={{
                            listStyle: "decimal",
                        }}
                        key={index}
                    >
                        {item}
                    </li>
                ))}
            </ul>
        </div>
    );
}
